<!-- 报告库 明细 sqm -->
<template>
  <ComponentRohsReport :kindType="data.kindType" :getData="data.getData" v-if="data.getData.supplyCode" @backBtn="routerBack"
    :subLoading="data.subLoading" v-loading="data.pageLoading"></ComponentRohsReport>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import ComponentRohsReport from "../ComponentRohsReport"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmDetail',
    getData:{},
    subLoading:false,
    pageLoading:false,
  })
  const routerBack = () => {
    proxy.$router.back()
  }
  const getInfo = () => {
    data.pageLoading = true
    proxy.$http({
          url: "/base/newrohs/getReportInfo?id="+ data.id,
          method: "get",
        }).then(res=>{
          if(res.data.data){
            data.getData = res.data.data
          }
        }).catch(err=>{

        }).finally(()=>{
          data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
          data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
          data.pageLoading = false
        })
  }

  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmDetail'
      data.id = route.query.id ?  route.query.id : undefined
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  route.query.trueName : ''
    }    
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    getInfo()
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
</script>

<style>

</style>